var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BaseListItem from '../base-list-item/base-list-item';
export var IconImageListItem = function (_a) {
    var color = _a.color, icon = _a.icon, title = _a.title, showDivider = _a.showDivider, backgroundColor = _a.backgroundColor, borderRadius = _a.borderRadius, onClick = _a.onClick;
    var iconSlotRender = function () {
        return (_jsx("div", __assign({ className: 'mr-2 flex flex-row items-center justify-center rounded-full p-4', style: { backgroundColor: color } }, { children: _jsx("img", { className: 'h-5 w-5', src: icon }) })));
    };
    return (_jsx(BaseListItem, { titleTypography: {
            text: title,
            color: 'primary',
            type: 'unspecified',
            fontSize: '16',
        }, backgroundColor: backgroundColor ? backgroundColor : 'white', onClick: onClick, dividerType: showDivider ? 'solid' : 'none', dividerColor: showDivider ? 'uiBg' : 'transparent', overwritePreSlotRender: iconSlotRender, borderRadius: borderRadius ? borderRadius : '' }));
};
//# sourceMappingURL=icon-image-list-item.js.map